import { useEffect, useState } from "react";
import { Package, Users, UserCheck, Download, ShoppingCart, Wallet, CheckCircle2 } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, CartesianGrid } from "recharts";
import { DashboardLayout } from "../../components/DashboardLayout";
import { ADMIN_MENU } from "../../lib/menus";
import { formatIDR } from "../../lib/format";
import api from "../../lib/api";

const COLORS = ["#4F46E5", "#0EA5E9", "#10B981", "#F59E0B", "#EF4444", "#8B5CF6", "#EC4899", "#14B8A6"];

export default function AdminDashboard() {
  const [s, setS] = useState(null);
  useEffect(() => {
    document.title = "Dashboard Admin - DS KODE";
    api.get("/admin/stats").then((r) => setS(r.data)).catch(() => {});
  }, []);

  const cards = [
    { label: "Total Produk", value: s?.total_products, icon: Package, cls: "bg-indigo-50 text-indigo-600" },
    { label: "Produk Aktif", value: s?.active_products, icon: CheckCircle2, cls: "bg-emerald-50 text-emerald-600" },
    { label: "Total Member", value: s?.total_members, icon: Users, cls: "bg-sky-50 text-sky-600" },
    { label: "Member Pending", value: s?.pending_members, icon: UserCheck, cls: "bg-amber-50 text-amber-600" },
    { label: "Total Download", value: s?.total_downloads, icon: Download, cls: "bg-violet-50 text-violet-600" },
    { label: "Total Pesanan", value: s?.total_orders, icon: ShoppingCart, cls: "bg-pink-50 text-pink-600" },
    { label: "Pendapatan", value: s ? formatIDR(s.revenue) : "-", icon: Wallet, cls: "bg-teal-50 text-teal-600" },
  ];

  return (
    <DashboardLayout title="Dashboard" menu={ADMIN_MENU} testid="admin-dashboard">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map((c) => (
          <div key={c.label} className="card p-4" data-testid={`admin-stat-${c.label.toLowerCase().replace(/\s/g, "-")}`}>
            <span className={`grid place-items-center h-10 w-10 rounded-lg ${c.cls} mb-3`}><c.icon className="h-5 w-5" /></span>
            <p className="text-2xl font-extrabold font-heading text-slate-900">{c.value ?? "-"}</p>
            <p className="text-xs text-slate-500 mt-0.5">{c.label}</p>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-6">
        <div className="card p-5 lg:col-span-2">
          <h3 className="font-heading font-bold text-slate-900 mb-4">Download 7 Hari Terakhir</h3>
          <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={s?.downloads_chart || []}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" />
                <XAxis dataKey="date" tick={{ fontSize: 12, fill: "#94a3b8" }} axisLine={false} tickLine={false} />
                <YAxis tick={{ fontSize: 12, fill: "#94a3b8" }} axisLine={false} tickLine={false} allowDecimals={false} />
                <Tooltip />
                <Bar dataKey="downloads" fill="#4F46E5" radius={[6, 6, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="card p-5">
          <h3 className="font-heading font-bold text-slate-900 mb-4">Distribusi Kategori</h3>
          <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie data={s?.category_distribution || []} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={80} innerRadius={45}>
                  {(s?.category_distribution || []).map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}
